import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { nomService } from '../../services/api/nom.service';
import { alertService } from '../../services/helpers/alert.service';
import { reportService } from '../../services/api/report.service';
import { utils } from "../../services/helpers/utils";

export const PatientAddSpecialConsultation = ({ cnp, activeComponent, pacient, searchCode }) => {
    const [abonamente, setAbonamente] = useState([]);
    const navigate = useNavigate();

    const partener = sessionStorage.getItem("idPartener");
    const rol = sessionStorage.getItem("rol");
    const haveLocations = sessionStorage.getItem('haveLocations') === 'false' ? false : true;

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(10);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;
    const currentItems = abonamente.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        nomService.getSpecialContracts({ partener: partener })
            .then(response => {
                if (response) {
                    setAbonamente(response);
                }
                else {
                    setAbonamente(null);
                }
            });
    }, [partener]);

    const handleView = (page, param, value) => {

        let partener = sessionStorage.getItem('idPartener');

        if (rol == 2) {
            alertService.error("Nu sunteti autorizat sa efectuati aceasta operatie!");
            return;
        }

        if (partener == 0) {
            alertService.error("Nu puteti efectua aceasta operatie fara a alege un partener!");
            return;
        }

        if (!haveLocations) {
            alertService.error("Nu aveti drept pe nici o locatie");
            return;
        }

        let queryString = '';

        // daca tipul lui param este obiect atunci il descompunem in cheie si valoare
        if (typeof param === 'object') {
            const keys = Object.keys(param);
            queryString = keys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(param[key])}`).join('&');
        }
        else {
            queryString = `${(param)}=${(value)}`;
        }
        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent,
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${queryString}`);
    }

    const handleExport = () => {
        if (abonamente.length == 0) {
            alertService.error("Nu exista randuri de exportat")
            return;
        }
        reportService.RaportAbonamenteSpeciale({ Code: cnp, Partener: 0 }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }


    return (
        <>
            {abonamente &&
                <>
                    <p className="paragraf">Abonamentele valabile ale acestui pacient:</p>
                    <table className="tbl" data-name="lista" width="100%">
                        <thead>
                            <tr>
                                <th>Nr</th>
                                <th>Companie</th>
                                <th>Tip abonament</th>
                                <th width="120" className="tac">Adaugă consultaţie</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((abonament, index) => (
                                <tr key={index}>
                                    <td data-name="nr_crt" className="center">{(currentPage - 1) * perPage + index + 1}</td>
                                    <td data-name="firma">{abonament.denumireFirma};</td>
                                    <td data-name="nume_profil">
                                        {abonament.denumireProfil}
                                        {abonament.firmaMaster && <span> (</span>}
                                        {abonament.firmaMaster}
                                        {abonament.firmaMaster && <span>)</span>}
                                    </td>
                                    <td className="center">
                                        <a className="icon editare m0auto"
                                            onClick={() => handleView("consultatie", { pacient: pacient, contract: abonament.idContract, speciala : true })}
                                            title="Adaugă consultaţie"
                                            data-name="adauga">Adaugă consultaţie</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                   

                    <div className="pagination">
                        <button
                            className="pagination-button"
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                        >
                            |&lt;
                        </button>
                        <button className="pagination-button"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                        &lt;
                        </button>
                        <button
                            className="pagination-button"
                            onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === Math.ceil(abonamente.length / perPage)}
                        >
                        &gt;
                        </button>
                        <button
                            className="pagination-button"
                            onClick={() =>
                                paginate(Math.ceil(abonamente.length / perPage))
                            }
                            disabled={
                                currentPage === Math.ceil(abonamente.length / perPage)
                            }
                        >
                        &gt;|
                        </button>
                </div>

                <div data-name="export">
                    <button data-name="btn-export" className="btn" onClick={handleExport}>Export</button>
                </div>
                </>
            }
        </>
    );
};

